export const DATE_RANGE_DAYS = 120;
export const HALF_DATE_RANGE_DAYS = DATE_RANGE_DAYS / 2; // 60 days - used for past/future date calculations
export const ISO_DATE_TIME_SEPARATOR = "T";

export const HOURS_IN_A_DAY = 24;
export const MS_PER_SECOND = 1000;
export const SECONDS_PER_MINUTE = 60;
export const MINUTES_PER_HOUR = 60;
export const MS_IN_AN_HOUR = MS_PER_SECOND * SECONDS_PER_MINUTE * MINUTES_PER_HOUR;

export const DAYS_IN_YEAR = 365;
export const MAX_DATE_RANGE_MS =
  DATE_RANGE_DAYS * HOURS_IN_A_DAY * MINUTES_PER_HOUR * SECONDS_PER_MINUTE * MS_PER_SECOND;
export const MIN_PAGE_NUMBER = 1;
export const MIN_PAGINATION_LIMIT = 1;
export const MAX_PAGINATION_LIMIT = 100;
